<input type="text" :value="modelValue" @input="updateInput" @blur="blurInput" :placeholder="placeholder" autocomplete="" :id="name" :maxlength="maxlength">